import React from "react";
import NewTopNavBar from "../NewTopNavBar";

const CallbackFunc = () => {
  return (
    <div>
      <NewTopNavBar />
      <h1>Callback</h1>
    </div>
  );
};

export default CallbackFunc;
